module.exports = __webpack_public_path__ + "media/images/icons/icon-xls-76c80c42a7b2458dc40656b417057ec0.svg";